import { render, staticRenderFns } from "./ProgressTip.vue?vue&type=template&id=5b2ac160&scoped=true"
import script from "./ProgressTip.vue?vue&type=script&lang=js"
export * from "./ProgressTip.vue?vue&type=script&lang=js"
import style0 from "./ProgressTip.vue?vue&type=style&index=0&id=5b2ac160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ac160",
  null
  
)

export default component.exports